/**
 * Google Analytics 4 — `VITE_GA_MEASUREMENT_ID`(G-XXXXXXXXXX) 가 있을 때만 붙는다. 없으면 전부 no-op.
 *
 * gtag.js 는 async 로 받고, 첫 page_view 는 우리가 직접 보낸다(`send_page_view: false`).
 * SPA 라 주소가 바뀌어도 문서가 다시 로드되지 않으므로, 라우터가 이동을 끝낼 때마다 page_view 를 보낸다.
 */
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export const analyticsEnabled = Boolean(ID) && typeof window !== 'undefined';

export function initAnalytics(): void {
  if (!analyticsEnabled) return;
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', ID, { send_page_view: false });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ID!)}`;
  document.head.appendChild(s);
}

let lastPath: string | null = null;

/** 라우트 이동마다 한 번. 같은 주소로 라우터가 두 번 resolve 해도(첫 로드 · 데이터 재로드) 한 번만 센다. */
export function trackPageView(pathWithSearch: string): void {
  if (!analyticsEnabled || !window.gtag) return;
  if (pathWithSearch === lastPath) return;
  lastPath = pathWithSearch;
  window.gtag('event', 'page_view', {
    page_path: pathWithSearch,
    page_location: window.location.origin + pathWithSearch,
    page_title: document.title,
  });
}
